export default function productFeed() {
  return {
    _id: false,
    type: 'droplet.productFeed',
    title: 'Latest Products',
    sort: 'newest',
    filters: [],
    match: 'all',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    itemCount: 4,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-feed/droplet.schema.js